import axios from "axios";
import { API_HOST } from "@/core/variables";

class DeploymentRepository {
    getAgentSummary = async (agentId: number) => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/summary`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    checkout = async (agentId: number, keepData: boolean) => {
        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/versions/checkout`, {
                agent_id: agentId,
                keep_data: `${keepData}`
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    train = async (agentId: number, description?: string) => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/training`,{
                params: {
                    description
                }
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    applyService = async (agentId: number) => {
        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/versions/deploy`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    findHistory = async (agentId: number, page: number, size: number) => {
        return axios.get(`${API_HOST}/v1/agents/${agentId}/history`, {
            params: {
                page: page,
                size: size
            }
        });
    };

    findTrainingHistory = async (agentId: number, page: number, size: number) => {
        return axios.get(`${API_HOST}/v1/agents/${agentId}/training/history`, {
            params: {
                page: page,
                size: size
            }
        });
    };
}

const deploymentRepository = new DeploymentRepository();

export default deploymentRepository;